<template>
  <v-row dense>
    <v-col
      cols="5"
      class="py-2"
    >
      <v-card class="pa-1 mr-1 d-flex align-center">
        <span class="subtitle-1">Залишок</span>
        <v-spacer />
        <span class="title">
          <ReportNumber :value="totalCurrentBalance" />
          <span class="font-weight-medium  body-1"> грн </span>
          <ReportNumber :value="totalCurrentBalanceHours" />
          <span class="font-weight-medium  body-1"> год</span>
        </span>
      </v-card>
    </v-col>
    <v-col
      cols="3"
      class="py-2"
    >
      <v-card class="pa-1 mx-1 d-flex align-center">
        <span class="subtitle-1">Рекомендовано</span>
        <v-spacer />
        <span class="title">
          <ReportNumber :value="totalRecommendedHours" />
          <span class="font-weight-medium  body-1"> год</span>
        </span>
      </v-card>
    </v-col>
    <v-col
      cols="4"
      class="py-2"
    >
      <v-card class="pa-1 ml-1 d-flex align-center">
        <span class="subtitle-1">До сплати</span>
        <v-spacer />
        <span class="title">
          <ReportNumber :value="totalPaymentAmount" />
          <span class="font-weight-medium  body-1"> грн</span>
        </span>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ReportNumber from "../../../components/ReportNumber.vue";
import * as baseRateApi from "../../../backend/baseRateApi.js";

export default {
  components: {
    ReportNumber,
  },
  props: [
    "totalCurrentBalanceHours",
    "totalRecommendedHours",
    "totalPaymentAmount",
  ],
  data: () => ({
    rate: null,
  }),
  computed: {
    totalCurrentBalance() {
      return this.totalCurrentBalanceHours * this.rate;
    },
  },
  created() {
    const today = this.moment().format("YYYY-MM-DD");
    baseRateApi.getRate(today).then((rate) => {
      this.rate = rate;
    });
  },
};
</script>
